import { FOOD_DETAILS_PATH } from '@/constants/paths';

export const getFoodDetailsPageUrl = (id: number) => {
  return FOOD_DETAILS_PATH.replace(':id', String(id));
};
